import { apiExpress } from 'lib/config';
import { useQueryFetch } from './useQueryFetch';

interface EncodeData {
  videoId: string;
  customerId: string;
}

interface EncodeVideoResponse {
  success: boolean;
  job_id: number;
}

export const useEncodeVideo = () => {
  const { data, error, loading, fetchData, progress } = useQueryFetch({
    pathname: '',
  });
  const fetch = (data: EncodeData) => {
    const { videoId } = data;
    return fetchData({
      method: 'post',
      url: `videos/${videoId}/encode`,
      baseURL: apiExpress,
    });
  };

  const encodeData: EncodeVideoResponse =
    (data && (data.data || data.jobId)) || null;

  return { encodeData, loading, error, fetch, progress };
};
